<div class="fud">

  <mat-dialog-content class="fud__content">

    <div class="fud__alert-banner">
      <mat-icon class="fud__alert-icon">warning</mat-icon>
      <h2 class="fud__title">Important Software Update!</h2>
      <button class="fud__close" (click)="close()" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p class="fud__intro">
      You have one or more Risycor(s) in your overview that are no longer up to date.<br>
      The deadline for the automatic update has passed. The update must now be performed manually
      via USB cable using the Resus PC Dashboard.<br>
      <strong>Your Risycor will continue to measure and log data, but the cloud connection will
      remain disconnected until the firmware is updated to version 2.066 or higher.</strong>
    </p>

    <div class="fud__section fud__section--offline">
      <h3 class="fud__section-title">
        <mat-icon>usb</mat-icon> Update via USB cable
      </h3>
      <p>Update the Risycor via USB cable using the Resus PC Dashboard.</p>
      <a href="https://www.resus.eu/sites/default/files/inline-files/TT53_How%20do%20I%20update%20a%20Risycor%20via%20the%20Resus%20PC%20Dashboard%20.pdf"
         target="_blank" rel="noopener" class="fud__link">
        Tips &amp; Tricks: How do I update a Risycor via the Resus PC Dashboard?
      </a>
      <h4 class="fud__subsection-title">How to check if the update succeeded?</h4>
      <p>
        In the Resus PC Dashboard, verify that:<br>
        Installed version ≥ <strong>2.066</strong>
      </p>
      <h4 class="fud__subsection-title">How to restore the cloud connection?</h4>
      <p>
        After updating, connect the Risycor to the internet. In the Resus Cloud Dashboard,
        go to <strong>"Manage risy-monitors"</strong> and verify that the status shows
        <strong>"Software up to date"</strong>.
      </p>
    </div>

    <div class="fud__important">
      <mat-icon class="fud__important-icon">error_outline</mat-icon>
      <div>
        <strong>Important:</strong>
        <p>Risycors that are not up to date will not be able to connect to the cloud until
          the firmware is manually updated via the Resus PC Dashboard.</p>
      </div>
    </div>

    <div class="fud__contact">
      <p>Please contact Resus if further support is required:</p>
      <p>
        <a href="mailto:info@resus.eu" class="fud__link">info@resus.eu</a><br>
        +32 3 640 33 91
      </p>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="fud__footer">
    <mat-checkbox [(ngModel)]="dontShowAgain" color="primary">
      Don't show this message again
    </mat-checkbox>
    <button mat-raised-button color="primary" (click)="close()">Close</button>
  </mat-dialog-actions>

</div>
